import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { PageTitle, PseudoStates } from '@cordata/buffet';

import { Form } from '~/components/CareTeam';

import { store } from '~/utils/care-team';

const PatientsCareTeamDetails = () => {
  const { id } = useParams();
  const [status, setStatus] = useState('loading');
  const [data, setData] = useState();

  useEffect(() => {
    if (id !== 'add') {
      store.getOne(id)
        .then(setData)
        .then(() => setStatus('success'))
        .catch(() => setStatus('error'));
    } else {
      setData({});
      setStatus('success');
    }
  }, [id]);

  if (status !== 'success') {
    return <PseudoStates status={status} />;
  }

  return (
    <>
      <PageTitle>
        Care Team Member
      </PageTitle>

      <Form
        data={{
          ...data,
        }}
        isAdd={id === 'add'}
      />
    </>
  );
};

export default PatientsCareTeamDetails;
